<div class="w-full flex-col space-y-2">
  <header class="header">
    <div class="flex items-center gap-[16px]">
      <!-- <button class="header__button">Nova Cotação</button> -->
      <div class="z-10">
        <app-menu-nova-cotacao [menusCotacao]="menusCotacao"></app-menu-nova-cotacao>
      </div>

      <!-- Desativado porenquanto -->
      <!-- <div class="flex items-center w-[450px] h-[40px] px-[8px] gap-[8px] border border-[#F9FAFB] rounded-[8px]">
      <ng-icon name="heroMagnifyingGlass" size="20px" color="#4B5563"></ng-icon>
      <input class="w-full h-full outline-none placeholder:text-[#6B7280]" type="text" placeholder="Busque por nome, placa, CPF/CNPJ">
    </div> -->
    </div>

    <ul class="header__actions flex items-center gap-[16px]">

      <!-- NOTIFICAÇÕES -->
      <li
        class="flex items-center justify-center w-[52px] h-[52px] border-[1px] border-[#D1D5DB] rounded-[8px] cursor-pointer relative text-icon-enabled transition"
        matTooltip="Notificações"
        [ngClass]="{'bg-text-interactive text-icon-inverse': headerService.isMenuOpen().notification}"
        [cdkMenuTriggerFor]="menuNotificacoes"
        (cdkMenuOpened)="headerService.isMenuOpen.set({notification: true, seguradoras: false})"
        (cdkMenuClosed)="headerService.isMenuOpen.set({notification: false, seguradoras: false})"
        data-testid="li_menu-notificacoes">
        @if (notificacoesNaoLidas() > 0) {
        <div class="flex items-center justify-center w-[24px] h-[24px] absolute right-[-8px] top-[-8px] bg-text-error text-text-invese rounded-full text-[12px] font-semibold">
          {{notificacoesNaoLidas()}}
        </div>
        }
        <ng-icon name="heroBell" size="20px"></ng-icon>
      </li>


      <ng-template #menuNotificacoes>
        <app-notificacoes [notificacoes]="notificacoes()" (visualizar)="marcarComoLida($event)" cdkMenu></app-notificacoes>
      </ng-template>

      @if ((platformService.deviceService.browser == 'Chrome' || platformService.deviceService.browser ==
      'MS-Edge-Chromium') && !utilsService.isMobile && statusExtensao()) {
      <!-- ACESSO RÁPIDO AS SEGURADORAS -->
      <li *showIfAuthorized="'ACESSO_RAPIDO_SEGURADORAS'"
        class="flex items-center justify-center w-[52px] h-[52px] border-[1px] border-[#D1D5DB] rounded-[8px] cursor-pointer text-icon-enabled transition"
        matTooltip="Acessar seguradoras"
        [ngClass]="{'bg-text-interactive text-icon-inverse': headerService.isMenuOpen().seguradoras}"
        [cdkMenuTriggerFor]="menuSeg"
        (cdkMenuOpened)="headerService.isMenuOpen.set({notification: false, seguradoras: true})"
        (cdkMenuClosed)="headerService.isMenuOpen.set({notification: false, seguradoras: false})"
        data-testid="li_menu-seguradoras">
        <ng-icon name="heroBuildingOffice2" size="20px"></ng-icon>
      </li>

      <ng-template #menuSeg>
        <app-menu-seguradoras cdkMenu></app-menu-seguradoras>
      </ng-template>
      } @else {
      <!-- BOTÃO INSTALAR EXTENSÃO -->
      <button *showIfAuthorized="'ACESSO_RAPIDO_SEGURADORAS'"
        class="flex items-center justify-center px-[16px] gap-[8px] h-[52px] text-[12px] border-[1px] border-[#D1D5DB] rounded-[8px] text-text-interactive font-semibold"
        (click)="instalarExtensao()"
        data-testid="btn_instalar-extensao">
        <ng-icon name="heroArrowDownTray" size="20px"></ng-icon>
        Instalar extensão
      </button>
      }

      <li tourAnchor="perfil-btn" class="flex items-center justify-center rounded-full cursor-pointer"
        [cdkMenuTriggerFor]="menu"
        data-testid="li_menu-usuario">

        @if (!isAlternativeAvatar) {
        <img class="w-[46px] h-[46px] rounded-[8px] border-[3px] border-[#FBBB21]" [src]="apiUsuario.avatar"
          alt="Avatar do usuário logado" (error)="setAlternativeAvatar()">
        } @else {
        <div
          class="flex items-center justify-center text-[16px] font-medium w-[52px] h-[52px] rounded-[8px] border-[3px] text-text-invese border-[#FBBB21] bg-[#005B87]">
          {{initialsName}}
        </div>
        }

        <ng-template #menu>
          <app-menu-user cdkMenu [avatar]="apiUsuario.avatar" (logoutEmitter)="logout()" [userData]="dadosUsuario"
            [initialsName]="initialsName" [isAlternativeAvatar]="isAlternativeAvatar"></app-menu-user>
        </ng-template>
      </li>
    </ul>
  </header>
  @if (showBannerVencimento() && !appService.isQuiverMax()) {
  <div class="h-12 flex-1 bg-white rounded-md justify-between px-3 flex flex-row items-center">
    <div class="flex flex-row gap-2 h-full items-center">
      <ng-icon [name]="billetDescriptionMap()?.icon" [style.color]="billetDescriptionMap()?.color"></ng-icon><span
        class="text-text-default font-[600]">{{billetDescriptionMap()?.description}}</span><span
        class="font-[400] text-[#606367]">Vencimento {{vencimento()}}</span>
    </div>
    <div class="flex flex-row space-x-4">
      <button (click)="imprimirFatura()"
        class="text-[#005B87] underline underline-offset-4 decoration-1 cursor-pointer font-semibold"
        gaEvent="ID_MEUPLANO_BOTAO_IMPRIMIR_BOLETO"
        data-testid="btn_imprimir-fatura">
        {{faturaLabel()}}
      </button>
      <button (click)="closeBanner()" data-testid="btn_close-banner">
        <ng-icon name="heroXMark"></ng-icon>
      </button>
    </div>
  </div>
  }
</div>
